<section class="service-deals-page">
  <!-- Breadcrumb / heading -->
  <div class="container fw-b service-deals-header">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems">
    </app-linker-route>
  </div>

  <!-- Main layout -->
  <div class="container wrapper-content service-deals-shell">
    <div class="service-deals-layout">
      <!-- Right: deals cards -->
      <section class="right-container">
        <!-- Deals grid -->
        <div class="deals-grid" *ngIf="serviceDetail?.length > 0">
          <div
            class="card-container"
            *ngFor="
              let item of serviceDetail
                | paginate
                  : {
                      itemsPerPage: pageSize,
                      currentPage: currentPage,
                      totalItems: totalItems
                    };
              let i = index
            ">
            <div class="innerDiv" [queryParams]="{_id: item?._id}" [routerLink]="['/service-provider-available-deals']">
              <category-layout-home [data]="item" [catName]="item?.categoryName"></category-layout-home>
            </div>
          </div>
        </div>

        <!-- Empty / loading state -->
        <div
          class="deals-empty-state d-flex align-items-center m-auto"
          *ngIf="!serviceDetail?.length && isLoading">
          <div class="no-data">
            <img src="assets/images/notfound.png" alt="No Data Found" />
            <p>No Data Found</p>
          </div>
        </div>
      </section>
    </div>

    <!-- Pagination -->
    <div class="custom-pagination mt-2 service-deals-pagination" *ngIf="totalItems > pageSize">
      <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
    </div>
  </div>
</section>
